import { CardVehicleAndDriver } from "@qivia/ui";
import { Tooltip } from "react-leaflet";
import { VehicleGeolocated } from "./index";

export const TooltipVehicleTrip = (props: {
  vehicle: VehicleGeolocated;
  handleSelectVehicle?: (vehicle: VehicleGeolocated) => void;
  rightElement?: JSX.Element;
  isPermanent?: boolean;
}) => {
  const { vehicle, handleSelectVehicle, isPermanent } = props;
  return (
    <Tooltip
      direction="top"
      offset={[0, -20]}
      opacity={1}
      permanent={isPermanent ?? false}
      key={`tooltip-${vehicle.uuid}`}
      className="vehicle-tooltip"
    >
      <CardVehicleAndDriver
        vehicle={vehicle}
        badgeText={vehicle.reference}
        rightElement={props.rightElement}
        driver={
          vehicle.driverName
            ? {
                firstName: vehicle.driverName.split(" ")[0] || "",
                lastName: vehicle.driverName.split(" ")[1] || "",
                phone: vehicle.driverPhone ?? "",
              }
            : undefined
        }
        distance={vehicle.distance || 0}
        onClick={() => handleSelectVehicle?.(vehicle) ?? undefined}
        $withShadow={true}
      />
    </Tooltip>
  );
};
